
import { getAutoTransferOverseasCustomerIdsApi } from '@/apis/inShipping'
import { getAllIncludePriceJpWhiteListApi } from '@/apis/user'
import { request } from '@/config/request/interceptors'

export default {
  namespaced: true,
  state: {
    // 是否是crossmall店铺
    isCrossMall: false,
    // 是否是固定一口价白名单
    isAllincludePriceJp: false,
    // 是否预约贩卖白明达
    isPreSaleWhiteList: false
  },
  getters: {
    isCrossMall(state: any) {
      return state.isCrossMall
    }
  },
  mutations: {
    SET_CROSS_MALL: (
      state: any,
      isWhite: boolean
    ): void => {
      state.isCrossMall = isWhite
    },
    SET_ALLINCLUDE_JP_PRICE: (
      state: any,
      isWhite: boolean
    ): void => {
      state.isAllincludePriceJp = isWhite
    },
    SET_PRE_SALE_WHITE_LIST: (
      state: any,
      isWhite: boolean
    ): void => {
      state.isPreSaleWhiteList = isWhite
    }
  },
  actions: {
    async getCrossMallShop(store: any) {
      const { commit, rootState } = store
      if (!rootState.route.curShop) {
        commit('SET_CROSS_MALL', false)
        return
      }
      const shopInfo = rootState.route?.user?.customerShopList?.find((v: any) => v.customerShopId === rootState.route.curShop)
      console.log('rootStaterootState', shopInfo)
      const res = await getAutoTransferOverseasCustomerIdsApi({})
      commit('SET_CROSS_MALL', res.data.includes(shopInfo?.customerId) && shopInfo?.customerShopPlatform !== 4)
    },
    async getAllinCludePriceWhite(store: any) {
      const { commit, rootState } = store
      if (!rootState.route.curShop) {
        commit('SET_ALLINCLUDE_JP_PRICE', false)
        return
      }
      const res = await getAllIncludePriceJpWhiteListApi({})
      commit('SET_ALLINCLUDE_JP_PRICE', res.data.includes(rootState.route.curShop))
    },
    async getCheckPreSaleWhiteList(store: any) {
      const { commit, rootState } = store
      if (!rootState.route.curShop) {
        commit('SET_PRE_SALE_WHITE_LIST', false)
        return
      }
      const res = await request.order.customer.platformOrderCheckPreSaleWhiteList({})
      commit('SET_PRE_SALE_WHITE_LIST', res.data)
    }
  }
}
